import React, { useState, useEffect } from "react";

function FileDnD({ onFilesChange, initialFiles }) {
  const [files, setFiles] = useState([]);
  const [fileDragging, setFileDragging] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [fileDropping, setFileDropping] = useState(null);

  useEffect(() => {
    if (initialFiles && initialFiles.length > 0) {
      setFiles(initialFiles);
      if (onFilesChange) onFilesChange(initialFiles);
    }
  }, [initialFiles]); // eslint-disable-line react-hooks/exhaustive-deps

  const humanFileSize = (size) => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  };

  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    if (onFilesChange) onFilesChange(updatedFiles);
  };

  const handleDrop = (event) => {
    event.preventDefault();

    const droppedFiles = Array.from(event.dataTransfer.files);
    const newFiles = [...files, ...droppedFiles];

    setFiles(newFiles);
    setFileDragging(null);
    setFileDropping(null);

    if (onFilesChange) onFilesChange(newFiles);
  };

  const handleDragEnter = (index) => setFileDropping(index);

  const handleDragStart = (index) => setFileDragging(index);

  const handleFilesAdded = (event) => {
    const newFiles = [...files, ...Array.from(event.target.files)];
    setFiles(newFiles);
    if (onFilesChange) onFilesChange(newFiles);
  };

  const loadFile = (file) => URL.createObjectURL(file);

  return (
    <div className="rounded-lg" onDrop={handleDrop}>
      <div
        className="relative flex flex-col text-gray-400 dark:text-gray-500 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg hover:border-primary dark:hover:border-primary transition-colors cursor-pointer"
        onDragOver={(e) => e.preventDefault()}
      >
        <input
          type="file"
          multiple
          className="absolute inset-0 z-10 w-full h-full p-0 m-0 outline-none opacity-0 cursor-pointer"
          onChange={handleFilesAdded}
        />
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <svg
            className="w-10 h-10 mb-2 text-gray-400 dark:text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Arrastra tus imagenes aqui o <span className="text-primary font-medium">hace clic</span> para subirlas
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">PNG, JPG, WEBP</p>
        </div>
      </div>

      {files.length > 0 && (
        <div className="grid grid-cols-2 gap-3 mt-4 md:grid-cols-5">
          {files.map((file, index) => (
            <div
              key={index}
              className={`relative flex flex-col items-center overflow-hidden text-center bg-gray-100 dark:bg-gray-700 border dark:border-gray-600 rounded-lg cursor-move select-none ${
                fileDragging === index ? "border-primary ring-2 ring-primary/30" : ""
              }`}
              style={{ paddingTop: "100%" }}
              draggable="true"
              onDragStart={() => handleDragStart(index)}
              onDragEnter={() => handleDragEnter(index)}
            >
              <button
                className="absolute top-1.5 right-1.5 z-10 p-1 bg-red-500 hover:bg-red-600 text-white rounded-full focus:outline-none transition-colors"
                type="button"
                onClick={() => removeFile(index)}
              >
                <svg
                  className="w-3.5 h-3.5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              {file.type && file.type.includes("image/") && (
                <img
                  className="absolute inset-0 z-0 object-cover w-full h-full"
                  src={loadFile(file)}
                  alt={file.name}
                />
              )}
              <div className="absolute bottom-0 left-0 right-0 flex flex-col p-1.5 text-xs bg-black/50 text-white">
                <span className="w-full font-medium truncate text-[10px]">
                  {file.name}
                </span>
                <span className="text-[10px] opacity-75">
                  {humanFileSize(file.size)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FileDnD;
